import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Drawer } from "vaul";
import * as S from "./styles";

interface DrawerComponentProps {
  triggerContent: React.ReactNode;
  width?: string;
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  description?: string;
  variant?: "filter" | "default";
  showCloseButton?: boolean;
  showSeparator?: boolean;
}

export function DrawerComponent({
  triggerContent,
  width,
  children,
  open,
  onOpenChange,
  title = "",
  description = "",
  variant = "default",
  showCloseButton = false,
  showSeparator = false,
}: DrawerComponentProps) {
  const { t } = useTranslation();

  const isControlled = typeof open !== "undefined";

  const [internalOpen, setInternalOpen] = useState(false);
  const drawerOpen = isControlled ? (open ?? false) : internalOpen;

  function handleSetOpen(newState: boolean) {
    if (isControlled) {
      onOpenChange && onOpenChange(newState);
    } else {
      setInternalOpen(newState);
    }
  }

  function handleClose() {
    handleSetOpen(false);
  }

  return (
    <Drawer.Root open={drawerOpen} onClose={() => handleSetOpen(false)}>
      <S.Trigger asChild onClick={() => handleSetOpen(true)}>
        {triggerContent}
      </S.Trigger>
      <Drawer.Portal>
        <S.Overlay />
        <S.Content width={width} variant={variant}>
          <S.HeaderContainer>
            <div>
              <S.HeaderTitle>{title}</S.HeaderTitle>
              {description && (
                <Drawer.Description>{description}</Drawer.Description>
              )}
            </div>
            {showCloseButton && (
              <S.CloseButton onClick={handleClose} title={t("close")}>
                <S.CloseIcon size={24} />
              </S.CloseButton>
            )}
          </S.HeaderContainer>
          {showSeparator && <S.Separator />}
          <S.ContentContainer>{children}</S.ContentContainer>
        </S.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
